export const TEST_ID = 'applicationsGridRowWrapper';
